<template>
  <div class="flex flex-col w-full mt-6">
    <div class="flex items-center" v-on:click="$emit('click', $event)">
      <span>{{ this.name }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5 ml-auto"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
    <div class="p-4 mt-4 rounded-lg bg-primary-dark" v-if="this.isOpen">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
